import { FC } from 'react';
import { Typography, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import ButtonDownloadAllFiles, { ButtonDownloadAllFilesProps } from 'components/ButtonDownloadAllFiles';
import FileViewerModal from 'components/FileViewerModal';
import useUploadDownload from 'utils/useUploadDownload';
import useFileUpload, { UseFileUploadOptions } from './useFileUpload';

const { Dragger } = Upload;

interface UploadDraggerProps extends UseFileUploadOptions {
  containerId?: string;
  uploadDragAreaCompact?: boolean;
  showRemoveIcon?: boolean;
  showDownloadIcon?: boolean;
  resource?: ButtonDownloadAllFilesProps['resource'];
  resourceIds?: ButtonDownloadAllFilesProps['ids'];
}

const UploadDragger: FC<UploadDraggerProps> = ({
  type,
  containerId,
  uploads,
  checkedFiles,
  setUploads,
  setLoading,
  uploadDragAreaCompact,
  showDownloadIcon,
  showRemoveIcon,
  resource,
  resourceIds,
  onRequest,
  onRemove,
  onCheckboxChange,
}) => {
  const { fileViewerModalProps, ...draggerProps } = useFileUpload({
    type,
    uploads,
    checkedFiles,
    setUploads,
    setLoading,
    onRequest,
    onRemove,
    onCheckboxChange,
  });

  const { onDownload } = useUploadDownload();

  return (
    <>
      <Dragger
        className={uploadDragAreaCompact ? 'ant-upload-drag-compact' : undefined}
        listType={type}
        fileList={uploads}
        showUploadList={{
          showPreviewIcon: true,
          showDownloadIcon,
          showRemoveIcon,
        }}
        multiple
        onDownload={onDownload}
        {...draggerProps}
      >
        <div id={containerId}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>

          <p className="ant-upload-text">Click or drag file to this area to upload</p>

          {!uploadDragAreaCompact && <p className="ant-upload-hint">Support for a single or bulk upload.</p>}
        </div>
      </Dragger>

      {uploads.length === 0 && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 18 }}>
          <Typography.Text>No items found</Typography.Text>
        </div>
      )}

      {resource && resourceIds && uploads.length > 0 && <ButtonDownloadAllFiles resource={resource} ids={resourceIds} />}

      <FileViewerModal {...fileViewerModalProps} />
    </>
  );
};

export default UploadDragger;
